module.exports = __webpack_public_path__ + "h5/img/b4.40b6a18d.jpeg";